var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14H0V5H3V14Z",
    fill: "#1C5158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49108 3H1.47404C0.578773 3 0 2.33303 0 1.49948C0 0.648306 0.5964 0 1.50865 0C2.42091 0 2.98269 0.648306 3 1.49948C3 2.33303 2.42091 3 1.49108 3Z",
    fill: "#1C5158"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 13.9998H11.0519V9.29535C11.0519 8.11371 10.6253 7.30738 9.55814 7.30738C8.74368 7.30738 8.25855 7.85096 8.04549 8.37598C7.96754 8.56414 7.94841 8.8263 7.94841 9.08911V14H5C5 14 5.03886 6.03183 5 5.20672H7.94841V6.45221C8.33968 5.85348 9.04046 5 10.6057 5C12.5456 5 14 6.25705 14 8.95797L13.9999 13.9998Z",
    fill: "#1C5158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.b1a91433d388529185f0622c45e15eae.svg";
export { ForwardRef as ReactComponent };